'use strict';

var internals = {};

module.exports = function () {};